import { useRef as useReactRef } from 'react'

export const useRef = useReactRef

export default useRef
